module.exports = __webpack_public_path__ + "static/fpb1-hero-08642fd390af213c398e623f977bfd4d.webp";